module.exports = __webpack_public_path__ + "img/achievement.809a6b8a.png";